import { trimbleIdentityEnvironment } from '../trimble-identity-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { userinfoSchema } from '../schemas/userinfo.schema';
import { TidAuthHeaders } from '../../../models/tid-auth-headers';
import { fromFetch } from 'rxjs/fetch';

/**
 * Get User information about authenticated user from Trimble Cloud
 * @returns information about authenticated user from Trimble Cloud
 */
export function getUserinfo(this: unknown) {
  return fromFetch(
    new Request(trimbleIdentityEnvironment.resolve(this).userInfoUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new TidAuthHeaders(),
      },
    })
  ).pipe(selectData(userinfoSchema));
}
